import { VoiceControlCard, VoiceControlPinDialog } from ".";
import {
  getControls,
  getSelectedDeviceData,
} from "../../redux/voiceControl-slice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { ReactComponent as AddNewDeviceIcon } from "../../assets/icons/add-device-icon.svg";
import { Link } from "../../components";
import { ReactComponent as PinIcon } from "../../assets/icons/voice/pin.svg";
import Skeleton from "react-loading-skeleton";
import cn from "classnames";
import sharedStyles from "../../shared.module.scss";
import styles from "./VoiceControlsList.module.scss";
import { useFormatMessage } from "../../i18n";

export function VoiceControlsList() {
  const [showModal, setShowModal] = useState(false);
  const SKELETONS_DEVICE_COUNT = 4;
  const tr = useFormatMessage();
  const dispatch = useDispatch();
  const deviceSelected = useSelector(getSelectedDeviceData);

  const skeletons = Array(SKELETONS_DEVICE_COUNT)
    .fill()
    .map((_, idx) => <Skeleton key={idx} className={styles.skeleton} />);

  useEffect(() => {
    if (deviceSelected.status === "ok" && !deviceSelected.loaded) {
      dispatch(getControls(deviceSelected.cloudId));
    }
  }, [deviceSelected, dispatch]);

  const controls = [...deviceSelected.configured].sort(
    (prevControl, nextControl) =>
      parseInt(prevControl.id) - parseInt(nextControl.id)
  );
  return (
    <div className={styles.voiceControlsList}>
      {!deviceSelected.loading ? (
        <>
          <div className={styles.linksContainer}>
            <Link
              className={styles.addNewControlLink}
              to={`/voice/${deviceSelected.cloudId}/controls/new`}
            >
              <div className={styles.addNewControlIcon}>
                <AddNewDeviceIcon />
              </div>
              <div>
                <span>{tr("add_control")}</span>
              </div>
            </Link>
            <Link
              className={cn(styles.addNewControlLink, sharedStyles.formText)}
              onClick={() => setShowModal(true)}
            >
              <div className={styles.addNewControlIcon}>
                <PinIcon />
              </div>
              <div>
                <span>{tr("configure_pin")}</span>
              </div>
            </Link>
            <VoiceControlPinDialog
              showModal={showModal}
              setShowModal={setShowModal}
            />
          </div>
          {controls.map((control) => (
            <VoiceControlCard control={control} key={control.id} />
          ))}
        </>
      ) : (
        skeletons
      )}
    </div>
  );
}
